import React from 'react'
import Button from "components/CustomButtons/Button.jsx";

const languages = require('../../assets/translate/translate_button.json')
let lang  =  localStorage.lang?localStorage.lang:'es'

function BivButtonCritical(props) {

  //const {active, onClick} = props

  BivButtonCritical.defaultProps = {
    onClick: () => null,
    active: false,
  }

  if (props.active === true) {
    return <Button
      color="danger"
      size="sm"
      simple
      round
      onClick={() => {props.onClick()}}
      >{languages[lang].button_critic}</Button>
  }

  return <Button
    color="danger"
    size="sm"
    round
    onClick={() => {props.onClick()}}
    >{languages[lang].button_critic}</Button>

}

export default BivButtonCritical